export const DEFAULT_ALERT = {
    showAlert: false,
    severity: "success",
    message: "",
  };